/* tslint:disable */

/**
 */
export class Tokens {
    TOKEN?: string;
    TYPE?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/tokens.ts